import styled from 'styled-components';

export const ListWrapper = styled.section`
  //
`;
